var helperCreateToNumber = require('./helperCreateToNumber')

/**
 * 转数值
 * @param { String/Number } str 数值
 *
 * @return {Number}
 */
var toNumber = helperCreateToNumber(parseFloat)

module.exports = toNumber



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/toNumber.js
// module id = 34
// module chunks = 98